<template>
    <div class="privacy-withdrawall__info">
        * {{ $t('You can at any time withdraw your consent to the processing of personal data by ' +
            'accessing your client account. Withdrawal of the agreement will not affect the lawfulness of ' +
            'the data processing carried out until the agreement is withdrawn') }}
    </div>
</template>

<script>
    import Vue from 'vue';

    export default Vue.component('PrivacyConsentWithdrawalInfo', {});
</script>


// WEBPACK FOOTER //
// src/app/modules/shared/components/PrivacyConsentWithdrawalInfo.vue